import React from "react";
import axios from 'axios';
import PaginationTable from "./PaginationTable";

import './table.css'

export default function TableWithAPI() {
  const [data, setData] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  const [total, setTotal] = React.useState(0)
  const [pageCount, setPageCount] = React.useState(0)

  const fetchData = async ({
    pageIndex,
    pageSize,
    number = '',
    bidding = '',

  }) => {
    const url = 'https://st.ccx.kz/api/lot/result/pagination/'
    await axios.get(`${url}?page=${pageIndex + 1}&page_size=${pageSize}&number=${number}&bidding=${bidding}`)
      .then(res => {
        setData(res.data['results']);
        setTotal(res.data['total']);
        setPageCount(Math.ceil(res.data['total'] / pageSize));
        setLoading(false);
      })
  };

  const columns = React.useMemo(
    () => [
      {
        Header: 'Номер лота',
        accessor: 'number',
        Cell: ({ value }) => <span className="nowrap">{value}</span>
      },
      {
        Header: 'Наименование лота',
        accessor: 'name',
      },
      {
        Header: 'Начало торгов',
        accessor: 'bidding_begin',
        Cell: ({ value }) => <span className="nowrap">{new Intl.DateTimeFormat("ru-RU", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        }).format(Date.parse(String(value).replace('Z', '.000Z')))}</span>,
      },
      {
        Header: 'Заключение сделки',
        accessor: 'result_created',
        Cell: ({ value }) => <span className="nowrap">{new Intl.DateTimeFormat("ru-RU", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        }).format(Date.parse(String(value)))}</span>,
      },
      {
        Header: 'Документы',
        accessor: 'documents',
        Cell: ({ value }) => <a href={value}>Скачать</a>
      },
      {
        Header: 'Статус',
        accessor: 'status',
      },
      {
        Header: 'Брокер победитель',
        accessor: 'winner',
        Cell: ({ value }) => {
          if (value) {
            return (<>{value.name}</>);
          }
          return '--';
        },
      },
      {
        Header: 'Итоговая сумма',
        accessor: 'best_sum',
        Cell: ({ value }) => {
          if (value) {
            return <span className="nowrap">{new Intl.NumberFormat("ru", { minimumFractionDigits: 2 }).format(value)}</span>;
          }
          return '--';
        },
      },
    ],
    []
  );

  return (
    <PaginationTable
      columns={columns}
      data={data}
      fetchData={fetchData}
      loading={loading}
      total={total}
      pageCount={pageCount}
    />
  );
}